import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../Input/Input';
import classes from './Search.module.scss';

export interface SearchProps {
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  size?: 'small' | 'medium';
}

const Search: FC<SearchProps> = ({
  disabled = false,
  className,
  placeholder,
  value,
  onChange,
  size = 'small',
}) => {
  const { t } = useTranslation();

  return (
    <Input
      disabled={disabled}
      className={classNames(classes.Search, className)}
      placeholder={placeholder || t('common:search')}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      size={size}
      InputProps={{
        endAdornment: (
          <FontAwesomeIcon
            className={classNames({ [classes.Icon]: !value })}
            onClick={value ? () => onChange('') : null}
            icon={!value ? faSearch : faTimes}
          />
        ),
      }}
    />
  );
};

export default Search;
